export default __webpack_public_path__ + "static/media/skipB.f083b8d7.png";